// eslint-disable-next-line
import i18n from "../../components/i18n";
import { useTranslation } from "react-i18next";

function Dashboard() {
  const { t } = useTranslation();
  var pandinItems = t("Pandin", { returnObjects: true });
  return (
    <div className="container-fluid dashboard py-5 pb-3">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 d-flex flex-column justify-content-center align-items-center first-section">
            <div className="col-12 d-flex justify-content-center title-container">
              <div className="title-row d-flex align-items-center justify-content-center">
                <div className="title">{pandinItems.Title}</div>
                <div className="animation-container-title"></div>
              </div>
            </div>
            <div className="col-12 text-center text-white-70 mt-2 mb-4 fs-5">
              {pandinItems.Subtitle}
            </div>
          </div>
          <div className="col-12 d-flex flex-column justify-content-center align-items-center second-section"></div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
